// src/pages/PaiementSucces.js
import React, { useEffect, useState } from "react";

export default function PaiementSucces() {
  const [countdown, setCountdown] = useState(5);

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((c) => {
        if (c <= 1) {
          clearInterval(timer);
          window.location.href = "/";
          return 0;
        }
        return c - 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  return (
    <div style={s.wrapper}>
      <div style={s.card}>
        <div style={s.icon}>🎉</div>
        <h1 style={s.title}>Paiement confirmé !</h1>
        <p style={s.desc}>
          Votre tombola a bien été surclassée en <strong>Plan Pro</strong>.
          Les modifications sont en cours d'application sur votre compte.
        </p>
        <div style={s.features}>
          {["✅ Billets illimités", "✅ Exports PDF/CSV / Affiches", "✅ Support prioritaire", "✅ Rapport financier complet"].map((f) => (
            <div key={f} style={s.feature}>{f}</div>
          ))}
        </div>
        <div style={s.countdown}>
          Configuration de votre espace… Redirection dans <strong>{countdown}</strong> secondes…
        </div>
        <button onClick={() => window.location.href = "/"} style={s.btn}>
          🚀 Accéder à mon tableau de bord Pro
        </button>
        <p style={s.invoice}>
          Une facture de confirmation vous a été envoyée par e-mail.
        </p>
      </div>
    </div>
  );
}

const s = {
  wrapper: { minHeight:"100vh", background:"linear-gradient(135deg,#1a3a8f,#764ba2)", display:"flex", alignItems:"center", justifyContent:"center", padding:"2rem" },
  card: { background:"#fff", borderRadius:"20px", maxWidth:"480px", width:"100%", padding:"2.5rem 2rem", textAlign:"center", boxShadow:"0 20px 60px rgba(0,0,0,0.2)" },
  icon: { fontSize:"4rem", marginBottom:"1rem" },
  title: { fontSize:"1.75rem", fontWeight:"900", color:"#1a1a2e", marginBottom:"0.5rem" },
  desc: { fontSize:"0.95rem", color:"#555", lineHeight:1.6, marginBottom:"1.5rem" },
  features: { display:"flex", flexDirection:"column", gap:"8px", background:"#e8f5e9", borderRadius:"12px", padding:"1.25rem", marginBottom:"1.5rem", textAlign:"left" },
  feature: { fontSize:"0.9rem", color:"#2e7d32", fontWeight:"600" },
  countdown: { fontSize:"0.85rem", color:"#aaa", marginBottom:"1rem" },
  btn: { width:"100%", padding:"1rem", background:"linear-gradient(135deg,#667eea,#764ba2)", color:"#fff", border:"none", borderRadius:"12px", fontWeight:"800", cursor:"pointer", fontSize:"1rem", marginBottom:"1rem" },
  invoice: { fontSize:"0.78rem", color:"#aaa" },
};